<template>
  <div v-show="episode.id">
    <div class="ep-data">
      <img :src="episodeImage"/>
      <div class="ep-data-text">
        <p><strong>S{{ episode.airedSeason }}E{{ episode.airedEpisodeNumber }} - {{ episode.episodeName }}</strong></p>
        <p><small>
          <span v-if="lastSeen < Date.now() - 1000">Last viewed: {{ new Date(episode.viewedAt) }}</span>
        </small></p>
        <p>{{ episode.overview }}</p>
        <div>
          <a :href="episode.playLinks.netflix" target="_blank" rel="noopener">
            <h3>Play in Netflix!</h3>
          </a>
        </div>
      </div>
    </div>

    <drinking-rules/>
  </div>
</template>

<script>
import DrinkingRules from '@/components/DrinkingRules';

export default {
  components: { DrinkingRules },
  name: 'episode',
  props: ['episode'],
  created() {
    this.setEpisodeImage();
  },
  data() {
    return {
      lastSeen: Date.now()
    };
  },
  watch: {
    episode() {
      this.lastSeen = this.episode.viewedAt;
      this.episode.viewedAt = Date.now();
      this.setEpisodeImage();
    }
  },
  methods: {
    setEpisodeImage() {
      this.episodeImage = `/static/episode-images/tng/${this.episode.id}.jpg`;
    }
  }
};
</script>

<style scoped>
.ep-data-text {
  text-align: left;
}

@media (min-width: 800px) {
  .ep-data {
    display: flex;
  }

  .ep-data img {
    /* Prevent episode image from stretching */
    object-fit: contain;
  }

  .ep-data-text {
    padding-left: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// Episode.vue?39e702ba